import { render, staticRenderFns } from "./SetStatusForm.vue?vue&type=template&id=8571843c&scoped=true"
import script from "./SetStatusForm.vue?vue&type=script&lang=js"
export * from "./SetStatusForm.vue?vue&type=script&lang=js"
import style0 from "./SetStatusForm.vue?vue&type=style&index=0&id=8571843c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8571843c",
  null
  
)

export default component.exports